<app-preloader *ngIf="isLoading()"></app-preloader>
<app-notifications></app-notifications>
<app-img-header
  title="Cotizador de Distribuidores"
  hasSubTitle="true"
  [subTitle]="
    id
      ? 'Editar propuesta para la cotización ' + dataService?.quoteName
      : 'Nueva propuesta para la cotización ' + dataService?.quoteName
  "
  alt="Daimler Truck"
  image="/assets/images/cotizador/intro.jpg"
>
</app-img-header>
<main class="main" id="standardQuotationDesktop">
  <div id="detail">
    <div class="pageWidth">
      <form [formGroup]="form">
        <!-- Crear componente para vista de Servicio Financiero -->
        <app-financial-service-view-desktop></app-financial-service-view-desktop>

        <app-customer-view-desktop></app-customer-view-desktop>

        <!-- Crear componente para vista de Unidad -->
        <app-models-view-desktop></app-models-view-desktop>
        <!-- <app-accessories-list></app-accessories-list> -->

        <app-financial-product-desktop
          formControlName="financialSetup"
          (financialConditionEmit)="setCondition($event)"
          [financialCondition]="form.controls['financialCondition'].value"
          [grace]="form.controls['grace'].value"
          [specialPayments]="form.controls['specialPayments'].value"
          [insurance]="form.controls['insurance'].value"
          [payments]="form.controls['payments'].value"
          (_deleteAllPayments)="deleteAllPayments()"
          (requestDownloadJson)="handleDownloadJson()"
          (deletePayments)="deleteDealPayments($event)"
        ></app-financial-product-desktop>

        <div class="actions">
          <button
            (click)="calculate()"
            class="secondary"
            [disabled]="isDisabledCalculateQuote"
          >
            Calcular
          </button>

          <button
            *ngIf="activarBotonJson"
            (click)="triggerDownloadJson()"
            class="secondary"
          >
            Descargar JSON
          </button>
        </div>
        <app-insurance
          *ngIf="canAddInsurance()"
          formControlName="insurance"
          (updateInsurance)="calculate()"
          (resetInsurance)="resetInsurance($event)"
          (resultCoverage)="coverageResult = $event"
          [idDeal]="idDeal"
          [idQuote]="id"
          [isValid]="isValid()"
          [isModelValid]="isModelValid()"
          [quoteType]="quoteType"
          [dealerId]="quoteService.formData?.dealerId"
          [dealerBranchId]="quoteService.formData?.wholeSaleId"
          [hasManualInsurance]="false"
          [grace]="form.controls['grace'].value"
          [specialPayments]="form.controls['specialPayments'].value"
          (insuranceSensitiveFieldsConfirm)="
            onInsuranceSensitiveFieldsConfirm()
          "
        ></app-insurance>
        <ng-container *ngIf="!canAddInsurance()">
          El seguro no está habilitado para esta combinación.
        </ng-container>

        <app-result-standard-desktop
          [financialProduct]="
            form.controls['financialSetup'].value?.financialProduct
          "
          [quoteResult]="form.controls['result'].value"
          [coverageResult]="form.controls['insurance'].value"
          [dealSummary]="form.getRawValue()"
        ></app-result-standard-desktop>
        <div class="textareaWrapper">
          <label for="comentario">Comentario</label>
          <textarea name="comentario" formControlName="comment"></textarea>
        </div>
        <!-- *ngIf="form.controls['financialSetup'].value?.financialProduct != 'PURE_LEASING'" -->
        <div
          id="amortizacionesYPagos"
          *ngIf="
            form.controls['financialSetup'].value?.financialProduct !=
            'PURE_LEASING'
          "
        >
          <div class="tabs w2">
            <a
              (click)="selectSection(1)"
              [ngClass]="{ active: showSection == 1 }"
              >Amortizaciones</a
            >
            @if (isAvailableInsurancePayments) {
              <a
                (click)="selectSection(2)"
                [ngClass]="{ active: showSection == 2 }"
                >Amortizaciones seguro</a
              >
            }
          </div>
          <div>
            <app-payments-standard-quote-desktop
              *ngIf="showSection == 1"
              [payments]="form.controls['payments'].value"
              [specialPayments]="form.controls['specialPayments'].value"
              [grace]="form.controls['grace'].value"
              [idQuote]="id"
              [idDeal]="idDeal"
              [result]="form.controls['result'].value"
              (updateSpecialPayments)="updateSpecialPayments($event)"
              (updateGrace)="updateGrace($event)"
              [tipoProductoFinanciero]="
                this.form.controls['financialSetup'].value
                  ? this.form.controls['financialSetup'].value.financialProduct
                  : null
              "
            ></app-payments-standard-quote-desktop>
            @if (showSection == 2) {
              <app-insurance-amortizations
                [payments]="insurancePayments"
                [quantity]="formQuantity"
                [currency]="formCurrency"
                [readOnly]="true"
                [tipoProductoFinanciero]="
                  this.form.controls['financialSetup'].value
                    ? this.form.controls['financialSetup'].value
                        .financialProduct
                    : null
                "
                [grace]="form.controls['grace'].value"
              ></app-insurance-amortizations>
            }
          </div>
        </div>
      </form>
      <div class="quotationActions">
        <button type="button" class="secondary" (click)="cancel()">
          Volver
        </button>
        <button
          type="button"
          class="primary"
          (click)="save(true)"
          [disabled]="this.form.invalid"
        >
          Guardar
        </button>
        <span *ngIf="showMessageCalculate" style="font-style: italic"
          >Para guardar, es necesario calcular previamente.</span
        >
      </div>
    </div>
  </div>
</main>
